import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ComboVinculo, Processo,  } from '../models/processo';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SeiService extends BaseService<Processo> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public updateProcess(obj: object, id: number = null): Observable<Processo> {
    const strId = id? '/' + id: ''
    return this.http.put<Processo>(this.baseUrl + strId, obj, { headers: this.headers });
  }

  public getComboVinculos(projetoId: number): Observable<ComboVinculo> {
    return this.http.get<ComboVinculo>(this.baseUrl + '/combo-vinculos', { params:{'projeto_id': projetoId}, headers: this.headers });
  }

  public listProcess(projetoId: number, filter:Record<string, string | number | boolean> = {}): Observable<Processo[]> {
    return this.http.get<Processo[]>(this.baseUrl , { params:{...filter, 'projeto_id': projetoId}, headers: this.headers });
  }

  public checkProcess(projetoId: number, processNumber: string): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/valida-processo', 
      { params:{'projeto_id': projetoId,'numeroProcesso': processNumber}, 
      headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/sei';
  }

}
